import FlipCard from "../../utility/Flipcard";
import { useTranslation } from "react-i18next";

function PartnerSection() {
  const { t } = useTranslation('lenderPage');

  return (
    <div className="lending-partner-section">
      {/* Background gradient container */}
      <div className="lending-partner-section-gradient-background" />

      {/* Content container */}
      <div className="lending-partner-section-content-container">
        <div className="lending-partner-section-header">
          <h2 className="lending-partner-section-title">
            {t("lending-partner-section-title")}
          </h2>
          <p className="lending-partner-section-description">
            {t("lending-partner-section-description")}
          </p>
        </div>

        {/* Partners grid */}
        <div className="lending-partner-section-grid">
          <FlipCard
            coverImage="/images/leadingPartners.png"
            name={"Lending Partner Name"}
            url={"https://www.example.com"}
            grievanceURL={"https://www.example.com/grievance"}
            pp={"https://www.example.com/privacy-policy"}
            tc={"https://www.example.com/terms-and-conditions"}
          />
          <FlipCard
            coverImage="/images/leadingPartners.png"
            name={"Lending Partner Name"}
            url={"https://www.example.com"}
            grievanceURL={"https://www.example.com/grievance"}
            pp={"https://www.example.com/privacy-policy"}
            tc={"https://www.example.com/terms-and-conditions"}
          />
          <FlipCard
            coverImage="/images/leadingPartners.png"
            name={"Lending Partner Name"}
            url={"https://www.example.com"}
            grievanceURL={"https://www.example.com/grievance"}
            pp={"https://www.example.com/privacy-policy"}
            tc={"https://www.example.com/terms-and-conditions"}
          />
          
        </div>
      </div>
    </div>
  );
}

export default PartnerSection;
